"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeTracking = initializeTracking;

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _initializeDelightedSurvey = _interopRequireDefault(require("@insided/deprecated-utils/initializeDelightedSurvey"));

function initializeTracking() {
  (0, _initializeDelightedSurvey.default)();

  if (window.sessionStorage.getItem('UserLoggedInControl')) {
    var userData = (0, _insidedDataStorage.getInsidedData)('user');

    if (userData) {
      _publish.default.trackEvent('userevent', {
        type: '[Control] User Visited',
        user_id: userData.userid,
        user_email: userData.email,
        user_name: userData.name,
        user_primary_role: userData.mainRole,
        user_custom_roles: userData.role
      });
    }

    window.sessionStorage.removeItem('UserLoggedInControl');
  }
}